import React, { useCallback } from "react";
import { LocalFilterChipBar } from "../../../components/dataTable";
import {
  BY_ORDER_FILTER_COLUMNS,
  buildLocalDistinctValues,
} from "./byOrderFilterUtils";

const ByOrderFilterBar = ({
  orderSummary,
  tableFilterQuery,
  onFilterChange,
}) => {
  const buildDistinct = useCallback(
    (dataSource, col) => buildLocalDistinctValues(dataSource, col),
    [],
  );

  return (
    <LocalFilterChipBar
      columns={BY_ORDER_FILTER_COLUMNS}
      tableFilterQuery={tableFilterQuery}
      onFilterChange={onFilterChange}
      buildDistinct={buildDistinct}
      dataSource={orderSummary}
    />
  );
};

export default ByOrderFilterBar;
